export default __webpack_public_path__ + "static/media/subAr.cef3cd8e.jpg";